import axios from "axios";
import { APIURL } from "../../../APIHandler/APIURL"
import { Headers } from "../../../APIHandler/HeaderAPI";
import { reloadHandler } from "../../../utlis/utlis";
import { Event_Details_failure, Event_Details_request, Event_Details_success } from "../../Reducer/EventDetails/EventDetailsSlice";

export const EventDetailsAPI = (payload) => async (dispatch, getState) => {
    dispatch(Event_Details_request())
    const auth_token = localStorage.getItem("auth_token")
    try {

        const { data } = await axios.get(`${APIURL.eventdetails}/${payload}`, {
            headers: {
                "host-url": Headers?.["host-url"],
                "language": Headers?.language,
               "event-slug":Headers?.["event-slug"],
                "Content-type": "application/json",
                Authorization: `Bearer ${auth_token}`
            },
        })
        // console.log("data", data)
        localStorage.setItem("userdetails",JSON.stringify(data))
        dispatch(Event_Details_success(data))
    } catch (error) {
        reloadHandler(error?.response?.status)
        dispatch(Event_Details_failure(error?.response?.data))

    }
}